/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import {UseFormRegisterReturn} from 'react-hook-form';
import {FieldWrapperPassThroughProps} from './AppFieldWrapper';
import React from "react";

type InputFieldProps = FieldWrapperPassThroughProps & {
    className?: string;
    textColor?: string;
    registration?: Partial<UseFormRegisterReturn>;
    onChangeSwitch?: (isChecked: boolean) => void;
    label: string;
    mt: any;
    mb: any;
    desc?: string;
    tooltip?: any;
};

export const AppSwitch = (props: InputFieldProps) => {
    const {label, className, registration, mt, mb, desc, error, tooltip, textColor, onChangeSwitch} = props;

    const handleInputChange = (changeEvent: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = changeEvent.target.checked;
        if (onChangeSwitch) {
            onChangeSwitch(isChecked);
        }

        if (registration?.onChange) {
            registration.onChange(changeEvent);
        }
    };

    return (
        <div className={`flex justify-start ${mt} ${mb} items-center gap-2.5`}>
            <div className="flex gap-4">
                <input
                    type="checkbox"
                    className={`relative h-5 w-10 appearance-none rounded-[20px] bg-[#e0e5f2] outline-hidden transition duration-[0.5s] 
                        before:absolute before:top-[50%] before:h-4 before:w-4 before:translate-x-[2px] before:translate-y-[-50%] before:rounded-[20px]
                        before:bg-white before:shadow-[0_2px_5px_rgba(0,0,0,.2)] before:transition before:content-[""]
                        checked:before:translate-x-[22px] hover:cursor-pointer
                        dark:bg-mono-400 checked:bg-mono-1000 dark:checked:bg-mono-600 ${className}`}
                    {...registration}
                    onChange={handleInputChange}
                />
                {tooltip}
            </div>
            <label className="hover:cursor-pointer">
                <span className={`text-base font-bold text-mono-600 ${textColor} dark:text-white`}>
                    {label}
                </span>
                {desc && <p className="text-base text-mono-600">{desc}</p>}
            </label>
            {error?.message && (
                <div role="alert" aria-label={error.message} className="text-sm font-semibold text-red-500">
                    {error.message}
                </div>
            )}
        </div>
    );
};
